import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) {
      return;
    }
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get(
      "session_id",
    );
    window.history.replaceState(null, "", window.location.pathname);
    const school = sessionStorage.getItem("aj-signup-school");
    const inviteToken = sessionStorage.getItem("aj-invite-token");
    sessionStorage.removeItem("aj-signup-school");
    api
      .post("/auth/google/session", {
        session_id: sid,
        school_name: school || null,
        invite_token: inviteToken || null,
      })
      .then(({ data }) => {
        sessionStorage.removeItem("aj-invite-token");
        setUser(data);
        navigate(data.role === "technician" ? "/prep" : "/chat", {
          replace: true,
          state: { user: data },
        });
      })
      .catch((e) => {
        sessionStorage.removeItem("aj-invite-token");
        toast.error(errMsg(e));
        setUser(false);
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser]);

  return null;
}
